
import {Component} from 'vue-property-decorator'
import { BaseHealthReportComponent, RequiredProjections } from '@/components/base/BaseMixins'

@RequiredProjections("*")
@Component({components: {}})
export default class HealthReportIcon extends BaseHealthReportComponent {

}
